module.exports = function(value, test) {
  if (value && value === test) {
    return "selected";
  }

  return '';
}
